import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RegistrationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Registration",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m19.88 7.69 1.41-1.41c0-.75-.62-1.36-1.38-1.35h-7.85v5.08c0 1.28-1.04 2.31-2.31 2.31H4.71v13.85c0 .8.75.96 1.39.96h13.82c.63 0 1.39-.2 1.39-.96v-3.75l2.8-2.76v6.52c0 2.2-1.71 3.7-4.16 3.7H6.16c-2.46 0-4.15-1.52-4.15-3.7V10.93a1 1 0 0 1 0-.26c.01-.12.05-.24.11-.34v-.08c.07-.1.14-.2.22-.29l7.41-7.41c.08-.1.17-.19.28-.26h.09c.1-.05.22-.1.33-.12.09-.01.18-.01.26 0h9.23c1.43.01 2.76.76 3.5 1.98.59-.58 1.54-.58 2.13 0l4.02 4.03c.56.58.56 1.51 0 2.09L17.57 22.29c-.16.17-.37.29-.59.35l-6.02 2.01c-.15.05-.31.08-.47.08-.41.02-.81-.14-1.1-.44-.4-.4-.55-1-.37-1.54l2.05-6.02c.08-.22.2-.43.36-.59l5.51-5.51 2.97-2.93Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M20.81 29.29h-7.39c-.63 0-1.14-.51-1.14-1.14v-7.38c0-.3.12-.59.33-.81l8.62-8.62c.21-.21.51-.33.81-.33s.59.12.81.33l7.38 7.38c.45.45.45 1.17 0 1.62l-8.61 8.62c-.21.21-.51.33-.81.33M14.57 27h5.77l7.47-7.47-5.77-5.77-7.47 7.47zM8.86 29.29H4.29c-1.89 0-3.43-1.54-3.43-3.43v-9.14a1.14 1.14 0 1 1 2.28 0v9.14c0 .63.51 1.14 1.14 1.14h4.57a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M2 13.29c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l9.14-9.15c.21-.21.51-.33.81-.33h13.71c1.89 0 3.43 1.54 3.43 3.43V11A1.14 1.14 0 1 1 26 11V5.29c0-.63-.51-1.14-1.14-1.14H11.62l-8.81 8.8c-.22.22-.52.33-.81.33Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.86 13.29H2a1.14 1.14 0 1 1 0-2.28h6.86c.63 0 1.14-.51 1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v6.86c0 1.89-1.54 3.43-3.43 3.43ZM26 24.1c-.29 0-.58-.11-.81-.33l-7.38-7.39a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l7.38 7.39A1.14 1.14 0 0 1 26 24.1"
      })]
    })
  }));
};